// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "fields-1aVKf";
var _3 = "controls-fPpvf";
var _4 = "cancel-1ytwK";
var _5 = "confirm-24mjy";
var _6 = "disabled-3px-m";
export { _1 as "__esModule", _2 as "fields", _3 as "controls", _4 as "cancel", _5 as "confirm", _6 as "disabled" }
export default { "__esModule": _1, "fields": _2, "controls": _3, "cancel": _4, "confirm": _5, "disabled": _6 }
